import { render, staticRenderFns } from "./PinCodeCome.vue?vue&type=template&id=2b4e8358&scoped=true"
import script from "./PinCodeCome.vue?vue&type=script&lang=js"
export * from "./PinCodeCome.vue?vue&type=script&lang=js"
import style0 from "./PinCodeCome.vue?vue&type=style&index=0&id=2b4e8358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e8358",
  null
  
)

export default component.exports